import {PayloadAction} from "@reduxjs/toolkit";
import {call, select, takeLatest,put , takeEvery} from "@redux-saga/core/effects";
import {
  formatDDMMYYYHHmm,
  getCustomerValue,
  getModelName,
  setLoadingPending, setLoadingRejected,
  setLoadingResolve,
  toast
} from '../../Utils/Utils';
import * as Services from "../../Services";
import {GET_SHIPMENTS, ShipmentParams, SHIPMENTS_WITH_BILL, ShipmentsWithBillParams} from './Types';
import {RootState} from "../Reducers";
import {ShipmentActions} from "./Slice";
import {Branch, City, Shipment, ShipmentType, Vehicle} from '../../Models';
import {Customer} from '../../Models/Customer';
import {LOADING_SHIPMENT_WITH_BILLS} from '../Loading/Types';

function* getShipments({payload}: PayloadAction<ShipmentParams>) {
  try {
    // yield put(setLoadingPending(LOADING_CANCEL_SHIPMENT));
    const { CompanyReducer : {company_selected, branch_selected}} = yield select((state: RootState) => state);
    let customer = getCustomerValue(company_selected, branch_selected);

    const res = yield call(Services.getShipments, customer as string, payload?.status);

    if (!res?.success) {
      throw Error('There was an error.');
    } else {
      yield put(ShipmentActions.setShipments(res?.results));
      // yield put(setLoadingResolve(LOADING_CANCEL_SHIPMENT));
    }
  } catch (e) {
    // yield put(setLoadingRejected(LOADING_CANCEL_SHIPMENT,  e.message));
    toast(e.message, "error");
  }
}


function* getShipmentsWithBill({payload}: PayloadAction<ShipmentsWithBillParams>) {
  let res;
  try {
    yield put(setLoadingPending(LOADING_SHIPMENT_WITH_BILLS));
    res = yield call(Services.getShipmentsWithBill, payload);
    if (res.success) {
      const shipments = res.results.reduce((acc: any, unit: any) => {
        const shipment = unit.shipment;
        unit.shipment = shipment._KEY;
        if (!acc[shipment._KEY]) {
          shipment.units = [];
          acc[shipment._KEY] = {
            _KEY: shipment._KEY,
            customer_payment_type: shipment.customer_payment_type,
            group: (shipment.group as ShipmentType).name,
            subgroup: (shipment.subgroup as ShipmentType).name,
            pickup_branch: (shipment.pickup_branch as Branch).name,
            pickup_vehicle: (shipment.pickup_vehicle as Vehicle).name,
            customer: getModelName(shipment.customer as Customer),
            customer_to_bill: shipment.customer_to_bill ?? {},
            pickup_date: formatDDMMYYYHHmm(new Date(shipment.pickup_date)),
            freight_value: shipment.freight_value,
            variable_freight: shipment.variable_freight,
            other_value: shipment.other_value,
            discount: shipment.discount || 0.0,
            total_value: shipment.total_value,
            status: shipment.status,
            consecutive: shipment.consecutive,
            pickup_city: (shipment.pickup_city as City).name,
            delivery_city: (shipment.delivery_city as City).name,
            units: [],
            receiver_name: shipment.receiver_name,
            delivery_date: shipment.delivery_date?formatDDMMYYYHHmm(new Date(shipment.delivery_date)):"",
            tracking_code: shipment.tracking_code,
            weight: unit.weight
          };
        }
        acc[shipment._KEY].units.push({_KEY: unit._KEY, quantity: unit.quantity});
        return acc;
      }, {});

      yield put(ShipmentActions.setShipmentsWithBill({
        by: payload.by,
        shipments: Object.values(shipments) as Shipment[]
      }));
      yield put(setLoadingResolve(LOADING_SHIPMENT_WITH_BILLS));
    } else {
      throw Error(res.message || "There was an error, please try again.");
    }
  } catch (e) {
    toast(e.message, 'error');
    console.error(e);
    yield put(setLoadingRejected(LOADING_SHIPMENT_WITH_BILLS, e.message))
  }
}

export function* shipmentSaga() {
  yield takeLatest(GET_SHIPMENTS, getShipments);
  yield takeEvery(SHIPMENTS_WITH_BILL, getShipmentsWithBill);
}
